import React from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { setFiltrosIntercia } from '../../store/actions/dashboard-intercia-action'
import { rangoContableInicial, sumarUnMes } from '../../common/dashboard-utils'
import * as estilos from '../../common/dashboard-estilos'

/**
 * Panel de filtros del tablero Inter Compañía — **drop 2026-09-22 (RG-541)**.
 *
 * 🔴 El período pasa de un rango de meses (dos combos alimentados por `meses-disponibles`) a un
 *    rango de **fechas exactas** con datepicker. Cambiar "Fecha Desde" ajusta "Fecha Hasta" a
 *    Desde + 1 mes (comportamiento contable 10→10); "Fecha Hasta" es libre. El botón Limpiar
 *    vuelve al rango contable inicial (`rangoContableInicial`), no a "sin filtro".
 */
const FiltroPanel = ({ onBuscar, companias = [] }) => {
    const dispatch = useDispatch()
    const filtros = useSelector((state) => state.dashboardInterciaReducer.filtros)

    const rangoInvalido = Boolean(
        filtros.fechaDesde && filtros.fechaHasta && filtros.fechaDesde > filtros.fechaHasta
    )

    // Cambiar Desde ajusta Hasta = Desde + 1 mes (comportamiento contable 10→10).
    const handleDesdeChange = (valor) => {
        dispatch(setFiltrosIntercia({ fechaDesde: valor, fechaHasta: sumarUnMes(valor) }))
    }

    // Cambiar Hasta NO afecta Desde — libertad al usuario.
    const handleHastaChange = (valor) => {
        dispatch(setFiltrosIntercia({ fechaHasta: valor }))
    }

    const limpiar = () => {
        dispatch(setFiltrosIntercia({ compania: '', ...rangoContableInicial() }))
    }

    return (
        <div style={estilos.filtroPanel}>
            <Row className='g-2 align-items-end'>

                <Col xs={12} md={4}>
                    <Form.Label className='fw-semibold small mb-1'>Compañía Tercero</Form.Label>
                    <Form.Select
                        size='sm'
                        value={filtros.compania}
                        onChange={(e) => dispatch(setFiltrosIntercia({ compania: e.target.value }))}
                    >
                        <option value=''>— Todas —</option>
                        {companias.map((c) => (
                            <option key={c.id} value={c.id}>{c.nombre}</option>
                        ))}
                    </Form.Select>
                </Col>

                <Col xs={6} md={3}>
                    <Form.Label className='fw-semibold small mb-1'>Fecha Desde</Form.Label>
                    <Form.Control
                        size='sm'
                        type='date'
                        value={filtros.fechaDesde}
                        onChange={(e) => handleDesdeChange(e.target.value)}
                        isInvalid={rangoInvalido}
                    />
                </Col>

                <Col xs={6} md={3}>
                    <Form.Label className='fw-semibold small mb-1'>Fecha Hasta</Form.Label>
                    <Form.Control
                        size='sm'
                        type='date'
                        value={filtros.fechaHasta}
                        onChange={(e) => handleHastaChange(e.target.value)}
                        isInvalid={rangoInvalido}
                    />
                </Col>

                <Col xs={12} md={2} className='d-flex align-items-end gap-2'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-100'
                        onClick={onBuscar}
                        disabled={rangoInvalido}
                    >
                        Buscar
                    </Button>
                    <Button variant='outline-secondary' size='sm' onClick={limpiar}>
                        Limpiar
                    </Button>
                </Col>

                {rangoInvalido && (
                    <Col xs={12}>
                        <div className='text-danger small mt-1'>
                            "Fecha Desde" debe ser menor o igual a "Fecha Hasta".
                        </div>
                    </Col>
                )}

            </Row>
        </div>
    )
}

export default FiltroPanel
